import { Link } from 'react-router-dom';
import { Phone, Calendar } from 'lucide-react';
import { Button } from '../ui/button';

const HeroSection = () => (
  <>
    <section className="relative overflow-hidden bg-slate-50" data-testid="hero-section">
      <div className="absolute inset-0 z-0">
        <img
          src="/images/hero-banner.jpg"
          alt="Dr. Boris Havkin, MD - Board-Certified Urologist"
          className="w-full h-full object-cover object-right md:object-center"
        />
        <div className="absolute inset-0 hero-gradient"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 lg:py-32">
        <div className="max-w-2xl">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-primary leading-tight mb-6 animate-fade-in">
            Welcome to Havkin Urology
          </h1>
          <p className="text-lg md:text-xl text-slate-600 mb-4 animate-fade-in stagger-1">
            After 12 years of taking care of patients as a partner at MIMA, Dr. Havkin is ready to welcome you to his own private practice.
          </p>
          <p className="text-base text-slate-500 mb-8 animate-fade-in stagger-1">
            The friendly team of well-trained and dedicated professionals remains the same. This speaks volumes of love for the field of urology and loyalty to Dr. Havkin. New patients are always welcome!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in stagger-2">
            <Button
              asChild
              size="lg"
              className="bg-brand hover:bg-brand-hover text-white rounded-full px-8 btn-press"
              data-testid="hero-appointment-btn"
            >
              <Link to="/contact">
                <Calendar className="h-5 w-5 mr-2" />
                Request Appointment
              </Link>
            </Button>
            <a
              href="tel:+13215004545"
              className="inline-flex items-center justify-center px-8 py-3 bg-white border border-slate-200 text-primary rounded-full font-medium hover:bg-slate-50 transition-colors btn-press"
              data-testid="hero-call-btn"
            >
              <Phone className="h-5 w-5 mr-2" />
              (321) 500-4545
            </a>
          </div>
        </div>
      </div>
    </section>

    <section className="bg-black" data-testid="video-section">
      <div className="w-full" style={{ aspectRatio: '1900/600' }}>
        <video autoPlay loop muted playsInline className="w-full h-full object-contain block">
          <source src="https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/tvykyp9r_Havkin_Hero%20Banner_1900x600%20%281%29-2.mp4" type="video/mp4" />
        </video>
      </div>
    </section>

    <section className="bg-white" data-testid="team-photo-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="rounded-2xl overflow-hidden shadow-lg">
          <img
            src="https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/oia4f47p_IMG_4332.jpg"
            alt="The Havkin Urology Team"
            className="w-full h-auto object-cover"
          />
        </div>
        <p className="text-center text-slate-500 mt-4 text-sm font-medium">The Havkin Urology Team</p>
      </div>
    </section>

    <section className="bg-slate-50" data-testid="dr-havkin-photo-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="rounded-2xl overflow-hidden shadow-lg max-w-xl mx-auto">
          <img
            src="https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/ktmtdyqh_IMG_4325.jpg"
            alt="Dr. Boris Havkin, MD"
            className="w-full h-full object-cover"
          />
        </div>
        <p className="text-center text-slate-500 mt-4 text-sm font-medium">Dr. Boris Havkin, MD — Board-Certified Urologist</p>
      </div>
    </section>
  </>
);

export default HeroSection;
